/* eslint-disable react/no-unknown-property */
import { h } from 'preact';
import SVGWrapper from '../../SVGWrapper';

function TvPlaylistIcon({ height = 60, width = 60 }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 70 70"
      fill="none"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M59.9455 37.6436C59.9455 38.7007 59.1421 39.5576 58.151 39.5576L12.7319 39.5576C11.7409 39.5576 10.9375 38.7006 10.9375 37.6435C10.9375 36.5864 11.7409 35.7295 12.7319 35.7295L58.151 35.7295C59.1421 35.7295 59.9455 36.5865 59.9455 37.6436Z" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M59.9455 51.6799C59.9455 52.737 59.1421 53.594 58.151 53.594L12.7319 53.594C11.7409 53.594 10.9375 52.737 10.9375 51.6799C10.9375 50.6228 11.7409 49.7659 12.7319 49.7659L58.151 49.7659C59.1421 49.7659 59.9455 50.6228 59.9455 51.6799Z" fill="white" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M60.0637 22.3311C60.0637 23.3882 59.2603 24.2451 58.2692 24.2451L30.5951 24.2451C29.6041 24.2451 28.8007 23.3882 28.8007 22.3311C28.8007 21.274 29.6041 20.417 30.5951 20.417L58.2692 20.417C59.2603 20.417 60.0637 21.274 60.0637 22.3311Z" fill="white" />
      <path d="M10.9375 27.1953V16.1907C10.9375 15.5102 11.769 15.0892 12.4241 15.438L23.2189 21.1867C23.872 21.5345 23.8536 22.3838 23.186 22.7088L12.3911 27.9648C11.7362 28.2836 10.9375 27.8608 10.9375 27.1953Z" fill="white" />
    </SVGWrapper>
  );
}

export default TvPlaylistIcon;
